import axios from 'axios';
import React, { useEffect, useState } from 'react'
import apiClient from '../../../utils/apiclient';
import { useNavigate } from 'react-router-dom';

const normalizeTimeSlot = (value) => {
  if (!value) return '';
  const time = String(value);
  return time.length === 5 ? `${time}:00` : time.slice(0, 8);
};

const displayTimeSlot = (value) => normalizeTimeSlot(value).slice(0, 5);

const hasSubscriptionAddOnMappings = (mappings) => {
  if (Array.isArray(mappings)) {
    return mappings.length > 0;
  }

  if (mappings && typeof mappings === 'object') {
    return Object.keys(mappings).length > 0;
  }

  return typeof mappings === 'string' && mappings.trim().length > 0;
};

const parseSubscriptionAddOnMappings = (mappings) => {
  if (Array.isArray(mappings)) {
    return mappings;
  }

  if (mappings && typeof mappings === 'object') {
    return [mappings];
  }

  if (typeof mappings === 'string' && mappings.trim()) {
    try {
      const parsedMappings = JSON.parse(mappings);
      if (Array.isArray(parsedMappings)) {
        return parsedMappings;
      }
      return parsedMappings && typeof parsedMappings === 'object'
        ? [parsedMappings]
        : [];
    } catch (error) {
      console.error('Unable to parse subscription add-on mappings:', error);
    }
  }

  return [];
};

const PendingSubscriptionOrders = ({route}) => {
  const SUBSCRIPTION_STATUSES = [
  "ordered",
  "delivered",
  "cancelled",
  "Refunded",
  "Rider is assigned",
  "on the way",
  "payment_initiated",
  "payment_cancelled"
];
const [page, setPage] = useState(0);
const [size] = useState(20);
const [loading, setLoading] = useState(false);
const [availableAddressMap, setAvailableAddressMap] = useState({});

const [totalPages, setTotalPages] = useState(0);
const [statusMap, setStatusMap] = useState({});
const [freebieMap, setFreebieMap] = useState({});
const [startTimeMap, setStartTimeMap] = useState({});
const [restaurantTimeSlotsMap, setRestaurantTimeSlotsMap] = useState({});
const [timeSlotLoadingMap, setTimeSlotLoadingMap] = useState({});
const [toast, setToast] = useState(null);
const [expandedAddOnMappings, setExpandedAddOnMappings] = useState({});


  const navigate=useNavigate();
    const [data,SetData]=useState([])
     const [search,Setsearch]=useState("")

useEffect(() => {
  fetchOrders();
}, [page, search]);

const fetchOrders = async () => {
  try {
        setLoading(true);

   const response = await apiClient.get(
  `/pendingSubscriptionorders?page=${page}&size=${size}&search=${search}`
);

    SetData(response.data.content);
    setTotalPages(response.data.totalPages);

    const map = {};
    const freebieStateMap = {};
    const startTimeStateMap = {};

    response.data.content.forEach((o) => {
      map[o.id] = o.status;
      freebieStateMap[o.id] = o.freebieDelivered ?? false;
      startTimeStateMap[o.id] = normalizeTimeSlot(o.startTime);
    });

    setStatusMap(map);
    setFreebieMap(freebieStateMap);
    setStartTimeMap(startTimeStateMap);

  } catch (e) {
    console.error(e);
  }finally {
    setLoading(false);
  }
};

const handleStartTimeFocus = async (restaurantId) => {
  if (!restaurantId || Object.prototype.hasOwnProperty.call(restaurantTimeSlotsMap, restaurantId)) {
    return;
  }

  setTimeSlotLoadingMap((prev) => ({
    ...prev,
    [restaurantId]: true,
  }));

  try {
    const response = await apiClient.get(`/get/timeslot/${restaurantId}`);
    const timeSlots = Array.isArray(response.data?.timeSlots)
      ? response.data.timeSlots.map(normalizeTimeSlot).filter(Boolean)
      : [];

    setRestaurantTimeSlotsMap((prev) => ({
      ...prev,
      [restaurantId]: timeSlots,
    }));
  } catch (e) {
    console.error(`Error fetching time slots for restaurant ${restaurantId}:`, e);
  } finally {
    setTimeSlotLoadingMap((prev) => ({
      ...prev,
      [restaurantId]: false,
    }));
  }
};
const handleStatusChange = (orderId, newStatus) => {
  setStatusMap((prev) => ({
    ...prev,
    [orderId]: newStatus,
  }));
};

const handleSaveStatus = async (orderId) => {
  const newStatus = statusMap[orderId];

  try {
    await apiClient.put(
      `/updateSubscriptionOrderStatus/${orderId}/${newStatus}`
    );

    // update table data locally
    SetData((prev) =>
      prev.map((order) =>
        order.id === orderId
          ? { ...order, status: newStatus }
          : order
      )
    );
  } catch (e) {
    console.error(e);
  }
};

const handleFreebieChange = (orderId, value) => {
  setFreebieMap((prev) => ({
    ...prev,
    [orderId]: value === 'true',
  }));
};

const handleSaveFreebie = async (orderId) => {
  const newStatus = freebieMap[orderId] ?? false;

  try {
    await apiClient.post('/update-freebieDelivered', {
      orderType: 'S',
      id: orderId,
      status: newStatus,
    });

    SetData((prev) =>
      prev.map((order) =>
        order.id === orderId
          ? { ...order, freebieDelivered: newStatus }
          : order
      )
    );
  } catch (e) {
    console.error(e);
  }
};

const handleStartTimeChange = async (orderId, updatedStartTime) => {
  const previousStartTime = startTimeMap[orderId] ?? '';
  const shouldUpdate = window.confirm(
    `Change subscription start time from ${previousStartTime || 'not set'} to ${updatedStartTime}?`
  );

  if (!shouldUpdate) {
    setStartTimeMap((prev) => ({
      ...prev,
      [orderId]: previousStartTime,
    }));
    return;
  }

  setStartTimeMap((prev) => ({
    ...prev,
    [orderId]: updatedStartTime,
  }));

  try {
    await apiClient.post(`/updatetimeslot/S/${orderId}/${updatedStartTime}`);

    setToast({ message: 'Subscription time slot updated successfully.', type: 'success' });
    setTimeout(() => setToast(null), 3000);

    SetData((prev) =>
      prev.map((order) =>
        order.id === orderId
          ? { ...order, startTime: updatedStartTime }
          : order
      )
    );
  } catch (e) {
    setStartTimeMap((prev) => ({
      ...prev,
      [orderId]: previousStartTime,
    }));
    setToast({ message: 'Failed to update subscription time slot.', type: 'error' });
    setTimeout(() => setToast(null), 3000);
    console.error('Error updating subscription start time:', e);
  }
};

const handleGetAvailableAddress = async (orderId) => {
  try {
    const response = await apiClient.get(`/getAvailableAddress/S/${orderId}`);
    const payload = response?.data ?? [];
    const addresses = Array.isArray(payload) ? payload : [payload];

    setAvailableAddressMap((prev) => ({
      ...prev,
      [orderId]: addresses,
    }));
  } catch (e) {
    console.error('Error fetching available address:', e);
  }
};

const handleAddressSelection = async (orderId, address) => {
  if (!address) return;

  const addressId = address.id ?? address.addressId;
  if (!addressId) {
    console.error('Address ID not found in selected address');
    return;
  }

  const shouldUpdate = window.confirm('Do you want to update this order address?');
  if (!shouldUpdate) return;

  try {
    await apiClient.post(`/getAvailableAddress/S/${orderId}/${addressId}`);
    console.log('Address updated for order', orderId, 'with addressId', addressId);
  } catch (e) {
    console.error('Error updating order address:', e);
  }
};

const toggleAddOnMappings = (orderId) => {
  setExpandedAddOnMappings((prev) => ({
    ...prev,
    [orderId]: !prev[orderId],
  }));
};

  const filteredData = data.filter((el) => {
    if (search.trim() === "") {
      return true; 
    }
    return (
      el.name?.toLowerCase().includes(search.toLowerCase()) || "-",
      el.number?.toString().includes(search) || "-",
      el.email?.toLowerCase().includes(search.toLowerCase()) || "-"
    );
  });
    const handlechange=(e)=>{
        const value=e.target.value;
        Setsearch(value);
        console.log(value)
    }
  return (
    <div className="w-full flex-1 flex flex-col min-h-0">
      {toast && (
        <div className={`fixed top-4 right-4 z-50 rounded px-4 py-3 text-sm text-white shadow-lg ${toast.type === 'success' ? 'bg-green-600' : 'bg-red-600'}`}>
          {toast.message}
        </div>
      )}
      <div className="flex justify-between items-center mb-2 flex-shrink-0 gap-3">
        <h2 className="text-base md:text-xl font-semibold text-gray-800 whitespace-nowrap">Pending Subscription Orders</h2>
        <input className="flex-1 border-2 py-1.5 px-3 md:py-2 md:px-4 text-sm md:text-base rounded-lg outline-none focus:border-blue-500 min-w-0"
          placeholder='Search...'
          onChange={handlechange}
          value={search}
        />
      </div>

     <div className="w-full flex-1 flex flex-col min-h-0">
    {loading ? (
<div className="absolute inset-0 bg-white/60 flex justify-center items-center z-10">
      Loading...
    </div>
) : ( <div className="w-full flex-1 overflow-auto pb-4 relative">
        <table className='min-w-max w-full bg-white shadow-md border-collapse'>
  <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
    <tr>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">SubscriptionOrder Id</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Add-on Mappings</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Available Address</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Public Id</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">customer Number</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">customer Name</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Meal Name</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">subscription  Order Instruction</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">OTP</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Restaurant Name</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Order Status</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Freebie Delivered</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Start Time</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">End Time</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Order Date</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Subscription Price</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Meal Plan</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">street</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">city</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">latitude</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">longitude</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Rider name</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Rider number</th>

          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Created At</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Updated At</th>

    </tr>
  </thead>
  <tbody>
{data.map((data, index) => {
  const currentStartTime = normalizeTimeSlot(startTimeMap[data.id] ?? data.startTime);
  const restaurantTimeSlots = restaurantTimeSlotsMap[data.restaurantid] ?? [];
  const timeSlots = currentStartTime && !restaurantTimeSlots.includes(currentStartTime)
    ? [currentStartTime, ...restaurantTimeSlots]
    : restaurantTimeSlots;
  const addOnMappings = data.subscriptionAddOnMappings;
  const hasAddOnMappings = hasSubscriptionAddOnMappings(addOnMappings);
  const parsedAddOnMappings = parseSubscriptionAddOnMappings(addOnMappings);
  const areAddOnMappingsExpanded = Boolean(expandedAddOnMappings[data.id]);

  return (
    <React.Fragment key={data.id ?? index}>
      <tr className='border border-gray-300 hover:bg-gray-50'>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">
          {data.id}
        </td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">
          <button
            type="button"
            aria-expanded={areAddOnMappingsExpanded}
            aria-controls={`subscription-add-on-mappings-${data.id}`}
            onClick={() => toggleAddOnMappings(data.id)}
            className={`px-2 py-1 rounded text-white text-[10px] md:text-xs font-medium ${
              hasAddOnMappings
                ? 'bg-green-600 hover:bg-green-700'
                : 'bg-red-600 hover:bg-red-700'
            }`}
          >
            {areAddOnMappingsExpanded ? 'Hide add-ons' : 'View add-ons'}
          </button>
        </td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">
          <div className="flex flex-col items-center justify-center gap-2">
            <button
              type="button"
              onClick={() => handleGetAvailableAddress(data.id)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-2 py-1 rounded text-[10px] md:text-xs font-medium whitespace-nowrap"
            >
              Get Available Address
            </button>

            {availableAddressMap[data.id] && availableAddressMap[data.id].length > 0 && (
              <select
                className="border rounded px-1 py-0.5 text-[10px] md:text-xs max-w-[180px]"
                defaultValue=""
                onChange={(e) => {
                  const selectedIndex = Number(e.target.value);
                  const selectedAddress = availableAddressMap[data.id][selectedIndex];
                  handleAddressSelection(data.id, selectedAddress);
                  e.target.value = "";
                }}
              >
                <option value="">Select address</option>
                {availableAddressMap[data.id].map((address, idx) => {
                  const label = typeof address === 'string'
                    ? address
                    : `${address?.street || ''}, ${address?.city || ''}, ${address?.postalCode || ''}`.replace(/,\s*,/g, ',').replace(/^,\s*|,\s*$/g, '') || `Address ${idx + 1}`;

                  return (
                    <option key={`${data.id}-${idx}`} value={idx}>
                      {label}
                    </option>
                  );
                })}
              </select>
            )}
          </div>
        </td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.publicId}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center hover:text-blue-900 hover:cursor-pointer hover:underline"
          onClick={() => navigate(`/userDetails/${data.number}`)}
        >
          {data.number}
        </td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.userdetails?.name?data.userdetails?.name:"-"}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.mealName}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.subscriptionOrderInstruction?data.subscriptionOrderInstruction:"no data"}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.otp}</td>

        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center hover:text-blue-900 hover:cursor-pointer hover:underline"
          onClick={() => navigate(`/restaurant/${data.restaurantid}`)}
        >
          {data.restaurantName}
        </td>
<td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">
  <div className="flex items-center justify-center gap-2">
    <select
      className="border rounded px-2 py-1"
      value={statusMap[data.id] ?? data.status}
      onChange={(e) =>
        handleStatusChange(data.id, e.target.value)
      }
    >
      {SUBSCRIPTION_STATUSES.map((status) => (
        <option key={status} value={status}>
          {status.replace(/_/g, " ").toUpperCase()}
        </option>
      ))}
    </select>

    {statusMap[data.id] !== data.status && (
      <button
        onClick={() => handleSaveStatus(data.id)}
        className="bg-green-600 text-white px-2 py-1 rounded text-sm"
      >
        Save
      </button>
    )}
  </div>
</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">
          <div className="flex items-center justify-center gap-2">
            <select
              className="border rounded px-2 py-1"
              value={String(freebieMap[data.id] ?? false)}
              onChange={(e) => handleFreebieChange(data.id, e.target.value)}
            >
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>

            {String(freebieMap[data.id] ?? false) !== String(data.freebieDelivered ?? false) && (
              <button
                onClick={() => handleSaveFreebie(data.id)}
                className="bg-indigo-600 hover:bg-indigo-700 text-white px-2 py-1 rounded text-sm font-medium"
              >
                Save Freebie
              </button>
            )}
          </div>
        </td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">
          <select
            className="border rounded px-2 py-1"
            value={startTimeMap[data.id] ?? normalizeTimeSlot(data.startTime)}
            onFocus={() => handleStartTimeFocus(data.restaurantid)}
            onChange={(e) => handleStartTimeChange(data.id, e.target.value)}
          >
            <option value="" disabled>Select time</option>
            {timeSlots.map((time) => (
              <option key={time} value={time}>
                {displayTimeSlot(time)}
              </option>
            ))}
            {timeSlotLoadingMap[data.restaurantid] && (
              <option value="" disabled>Loading times...</option>
            )}
          </select>
        </td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.endTime}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.orderdate}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.mealplanprice}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.mealplanname}</td>
       <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.city}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.street}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.latitude}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.longitude}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.riderDetails?.name?data.riderDetails.name:"-"}</td>
            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.riderDetails?.number?data.riderDetails.number:"-"}</td>
            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.createdAt?data.createdAt.split("T")[1].split(".")[0]:"-"}</td>
            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.updatedAt?data.updatedAt.split("T")[1].split(".")[0]:"-"}</td>
      </tr>
      {areAddOnMappingsExpanded && (
            <tr id={`subscription-add-on-mappings-${data.id}`} className="border border-gray-300 bg-gray-50">
              <td colSpan={25} className="px-4 py-3">
                <div className="text-left">
                  <h3 className="mb-2 text-xs md:text-sm font-semibold text-gray-800">
                    Subscription add-on mappings for order {data.id}
                  </h3>
                  {parsedAddOnMappings.length > 0 ? (
                    <div className="overflow-auto">
                      <table className="min-w-max w-full border-collapse bg-white text-[10px] md:text-xs">
                        <thead className="bg-gray-800 text-white">
                          <tr>
                            <th className="border px-2 py-2">Id</th>
                            <th className="border px-2 py-2">Item Mapping Id</th>
                            <th className="border px-2 py-2">Item Id</th>
                            <th className="border px-2 py-2">Name</th>
                            <th className="border px-2 py-2">Price</th>
                            <th className="border px-2 py-2">Description</th>
                            <th className="border px-2 py-2">Public Lunch Description</th>
                            <th className="border px-2 py-2">Public Dinner Description</th>
                            <th className="border px-2 py-2">Count</th>
                            <th className="border px-2 py-2">Mapping Price</th>
                            <th className="border px-2 py-2">Status</th>
                            <th className="border px-2 py-2">Razorpay Order Id</th>
                            <th className="border px-2 py-2">Razorpay Payment Id</th>
                          </tr>
                        </thead>
                        <tbody>
                          {parsedAddOnMappings.flatMap((mapping, mappingIndex) => {
                            const items = Array.isArray(mapping.items) ? mapping.items : [];
                            const rows = items.length > 0 ? items : [null];

                            return rows.map((entry, itemIndex) => (
                              <tr
                                key={`${mapping.id ?? mappingIndex}-${entry?.id ?? itemIndex}`}
                                className="border"
                              >
                                <td className="border px-2 py-2 text-center">{mapping.id ?? '-'}</td>
                                <td className="border px-2 py-2 text-center">{entry?.id ?? '-'}</td>
                                <td className="border px-2 py-2 text-center">{entry?.item?.id ?? '-'}</td>
                                <td className="border px-2 py-2">{entry?.item?.name ?? '-'}</td>
                                <td className="border px-2 py-2 text-center">{entry?.item?.price ?? '-'}</td>
                                <td className="border px-2 py-2">{entry?.item?.description ?? '-'}</td>
                                <td className="border px-2 py-2">{entry?.item?.publiclunchDescription ?? '-'}</td>
                                <td className="border px-2 py-2">{entry?.item?.publicdinnerDescription ?? '-'}</td>
                                <td className="border px-2 py-2 text-center">{entry?.count ?? '-'}</td>
                                <td className="border px-2 py-2 text-center">{mapping.price ?? '-'}</td>
                                <td className="border px-2 py-2 text-center">{mapping.status ?? '-'}</td>
                                <td className="border px-2 py-2 text-center">{mapping.razorpayOrderId ?? '-'}</td>
                                <td className="border px-2 py-2 text-center">{mapping.razorpayPaymentId ?? '-'}</td>
                              </tr>
                            ));
                          })}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p className="text-[10px] md:text-xs text-gray-600">No add-on mappings for this order.</p>
                  )}
                </div>
              </td>
            </tr>
      )}
    </React.Fragment>
    )})}
  </tbody>
</table>
      </div>
)}

 </div>
 <div className="flex justify-center items-center gap-4 mt-0 pb-4 flex-shrink-0">
        <button
          disabled={page === 0 || loading}
          onClick={() => setPage((prev) => prev - 1)}
          className="px-6 py-2 bg-gray-800 text-white font-semibold rounded disabled:opacity-50 hover:bg-gray-700 transition-colors"
        >
          Previous
        </button>

        <span className="font-medium text-gray-700">
          Page {page + 1} of {totalPages}
        </span>

        <button
          disabled={page >= totalPages - 1 || loading}
          onClick={() => setPage((prev) => prev + 1)}
          className="px-6 py-2 bg-gray-800 text-white font-semibold rounded disabled:opacity-50 hover:bg-gray-700 transition-colors"
        >
          Next
        </button>
      </div>
   </div>
  )
}

export default PendingSubscriptionOrders